import { createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = { class: "history-row" };
const _hoisted_2 = { class: "td__item-name" };
const _hoisted_3 = { class: "td__amount" };
const _hoisted_4 = { class: "td__tax-amount" };
const _hoisted_5 = { class: "td__total-amount" };
const _hoisted_6 = { class: "td__content" };
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    return (_openBlock(), _createElementBlock("tr", _hoisted_1, [
        _createCommentVNode(" 품목 "),
        _createElementVNode("td", _hoisted_2, _toDisplayString(_ctx.list.text), 1 /* TEXT */),
        _createCommentVNode(" 공급가액 "),
        _createElementVNode("td", _hoisted_3, _toDisplayString(_ctx.amount), 1 /* TEXT */),
        _createCommentVNode(" 세액 "),
        _createElementVNode("td", _hoisted_4, _toDisplayString(_ctx.taxAmount), 1 /* TEXT */),
        _createCommentVNode(" 합계액 "),
        _createElementVNode("td", _hoisted_5, _toDisplayString(_ctx.totalAmount), 1 /* TEXT */),
        _createCommentVNode(" 비고 "),
        _createElementVNode("td", _hoisted_6, _toDisplayString(_ctx.content), 1 /* TEXT */)
    ]));
}
